import { render } from "./ComponentSetting.vue?vue&type=template&id=1f66c344&scoped=true"
import script from "./ComponentSetting.vue?vue&type=script&lang=js"
export * from "./ComponentSetting.vue?vue&type=script&lang=js"

import "./ComponentSetting.vue?vue&type=style&index=0&id=1f66c344&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/localhost/html/miw-alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f66c344"]])

export default __exports__